import React, { useState } from 'react'
import styles from './AdminPanelPage.module.scss'
import { Button, Layout } from "components";
import passkk from "assets/img/passkk.png"
import {
	createGuard,
	getGuards,
	createTopBase,
	getTopBases,
	createTopBaseOperator,
	getTopBaseOperators,
	createDriver,
	getDrivers,
	getAllEmployees,
	updateGuard,
	updateTopBase,
	updateTopBaseOperator,
	updateDriver,
	blockDriver,
	unblockDriver,
	uploadDriverDocuments,
	uploadOperatorDocuments,
	// CHPP
	createChpp,
	getChpps,
	createChppOperator,
	getChppOperators,
	updateChpp,
	updateChppOperator,
	// Private Points
	createPrivatePoint,
	getPrivatePoints,
	createPrivatePointOperator,
	getPrivatePointOperators,
	updatePrivatePoint,
	updatePrivatePointOperator,
	// Branches
	updateBranch,
	createTopBaseBranch,
	createChppBranch,
	createPrivatePointBranch,
	updateTopBaseBranch,
	updateChppBranch,
	updatePrivatePointBranch,
	getTopBaseBranches,
	getChppBranches,
	getPrivatePointBranches,
	getBranches
} from "service/AdminPanelService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import Notification from "utils/Notifications";
import CreateGuardForm from './Forms/CreateGuardForm'
import CreateTopBaseForm from './Forms/CreateTopBaseForm'
import CreateOperatorForm from './Forms/CreateOperatorForm'
import CreateDriverForm from './Forms/CreateDriverForm'
import CreateChppForm from './Forms/CreateChppForm'
import CreateChppOperatorForm from './Forms/CreateChppOperatorForm'
import CreateChppDriverForm from './Forms/CreateChppDriverForm'
import CreatePrivatePointForm from './Forms/CreatePrivatePointForm'
import CreatePrivatePointOperatorForm from './Forms/CreatePrivatePointOperatorForm'
import CreatePrivatePointDriverForm from './Forms/CreatePrivatePointDriverForm'
import CreateBranchForm from './Forms/CreateBranchForm'
import GuardsPanel from './Blocks/GuardsPanel'
import TopBasesPanel from './Blocks/TopBasesPanel'
import ChppsPanel from './Blocks/ChppsPanel'
import PrivatePointsPanel from './Blocks/PrivatePointsPanel'
import TopBasesMapView from './Blocks/TopBasesMapView'
import ChppsMapView from './Blocks/ChppsMapView'
import PrivatePointsMapView from './Blocks/PrivatePointsMapView'
import AllDriversPanel from './Blocks/AllDriversPanel'
import LoadsPanel from './Blocks/LoadsPanel'
import DriverCheckedPanel from './Blocks/DriverCheckedPanel'
import BaseRequestsAdminPanel from './Blocks/BaseRequestsAdminPanel'
import KomurSvyazContent from 'pages/KomurSvyazPage/KomurSvyazPage'

const AdminPanelPage = () => {

	const [open, setOpen] = useState(null)

	const toggle = (id) => setOpen((prev) => (prev === id ? null : id))
	const [notify, setNotify] = useState({
		isOpen: false,
		message: "",
		type: "",
	});
	// data
	const [guards, setGuards] = useState([])
	const [topBases, setTopBases] = useState([])
	const [chpps, setChpps] = useState([])
	const [privatePoints, setPrivatePoints] = useState([])
	const [allPrivatePoints, setAllPrivatePoints] = useState([])
	const [drivers, setDrivers] = useState([])
	const [guardsPagination, setGuardsPagination] = useState({})
	const [topBasesPagination, setTopBasesPagination] = useState({})
	const [chppsPagination, setChppsPagination] = useState({})
	const [privatePointsPagination, setPrivatePointsPagination] = useState({})
	const [driversPagination, setDriversPagination] = useState({})
	const [guardsFilter, setGuardsFilter] = useState('')
	const [topBasesFilter, setTopBasesFilter] = useState('')
	const [chppsFilter, setChppsFilter] = useState('')
	const [privatePointsFilter, setPrivatePointsFilter] = useState('')
	const [driversFilter, setDriversFilter] = useState('')
	const [operatorsByTopBase, setOperatorsByTopBase] = useState({})
	const [operatorsPaginationByTopBase, setOperatorsPaginationByTopBase] = useState({})
	const [driversByTopBase, setDriversByTopBase] = useState({})
	const [driversPaginationByTopBase, setDriversPaginationByTopBase] = useState({})
	const [branchesByTopBase, setBranchesByTopBase] = useState({})
	const [branchesPaginationByTopBase, setBranchesPaginationByTopBase] = useState({})
	const [operatorsByChpp, setOperatorsByChpp] = useState({})
	const [operatorsPaginationByChpp, setOperatorsPaginationByChpp] = useState({})
	const [driversByChpp, setDriversByChpp] = useState({})
	const [driversPaginationByChpp, setDriversPaginationByChpp] = useState({})
	const [branchesByChpp, setBranchesByChpp] = useState({})
	const [branchesPaginationByChpp, setBranchesPaginationByChpp] = useState({})
	const [operatorsByPrivatePoint, setOperatorsByPrivatePoint] = useState({})
	const [operatorsPaginationByPrivatePoint, setOperatorsPaginationByPrivatePoint] = useState({})
	const [driversByPrivatePoint, setDriversByPrivatePoint] = useState({})
	const [driversPaginationByPrivatePoint, setDriversPaginationByPrivatePoint] = useState({})
	const [branchesByPrivatePoint, setBranchesByPrivatePoint] = useState({})
	const [branchesPaginationByPrivatePoint, setBranchesPaginationByPrivatePoint] = useState({})
	const [allBranches, setAllBranches] = useState([])
	const [expandedOperatorsTopBase, setExpandedOperatorsTopBase] = useState(null)
	const [expandedDriversTopBase, setExpandedDriversTopBase] = useState(null)
	const [expandedBranchesTopBase, setExpandedBranchesTopBase] = useState(null)
	const [expandedOperatorsChpp, setExpandedOperatorsChpp] = useState(null)
	const [expandedDriversChpp, setExpandedDriversChpp] = useState(null)
	const [expandedBranchesChpp, setExpandedBranchesChpp] = useState(null)
	const [expandedOperatorsPrivatePoint, setExpandedOperatorsPrivatePoint] = useState(null)
	const [expandedDriversPrivatePoint, setExpandedDriversPrivatePoint] = useState(null)
	const [expandedBranchesPrivatePoint, setExpandedBranchesPrivatePoint] = useState(null)
	const [operatorsFilterByTopBase, setOperatorsFilterByTopBase] = useState({})
	const [driversFilterByTopBase, setDriversFilterByTopBase] = useState({})
	const [branchesFilterByTopBase, setBranchesFilterByTopBase] = useState({})
	const [operatorsFilterByChpp, setOperatorsFilterByChpp] = useState({})
	const [driversFilterByChpp, setDriversFilterByChpp] = useState({})
	const [branchesFilterByChpp, setBranchesFilterByChpp] = useState({})
	const [operatorsFilterByPrivatePoint, setOperatorsFilterByPrivatePoint] = useState({})
	const [driversFilterByPrivatePoint, setDriversFilterByPrivatePoint] = useState({})
	const [branchesFilterByPrivatePoint, setBranchesFilterByPrivatePoint] = useState({})
	// which driver (by id) is expanded per top base (shows passkk image)
	const [expandedDriverByTopBase, setExpandedDriverByTopBase] = useState({})
	const [expandedDriverByChpp, setExpandedDriverByChpp] = useState({})
	const [expandedDriverByPrivatePoint, setExpandedDriverByPrivatePoint] = useState({})
	// which operator (by id) is expanded per entity
	const [expandedOperatorByTopBase, setExpandedOperatorByTopBase] = useState({})
	const [expandedOperatorByChpp, setExpandedOperatorByChpp] = useState({})
	const [expandedOperatorByPrivatePoint, setExpandedOperatorByPrivatePoint] = useState({})

	// UI state for expansion and modals
	const [expandedTopBase, setExpandedTopBase] = useState(null)
	const [expandedChpp, setExpandedChpp] = useState(null)
	const [expandedPrivatePoint, setExpandedPrivatePoint] = useState(null)
	const [modalOpen, setModalOpen] = useState(false)
	const [modalType, setModalType] = useState(null) // 'guard'|'topbase'|'operator'|'driver'
	const [modalPayload, setModalPayload] = useState({})
	const [employees, setEmployees] = useState([])
	const [employeeSearch, setEmployeeSearch] = useState('')
	const [copiedUid, setCopiedUid] = useState(null)

	// inline edit states
	const [editingGuard, setEditingGuard] = useState(null)
	const [editingTopBase, setEditingTopBase] = useState(null)
	const [editingChpp, setEditingChpp] = useState(null)
	const [editingPrivatePoint, setEditingPrivatePoint] = useState(null)
	const [editingOperatorByTopBase, setEditingOperatorByTopBase] = useState({})
	const [editingDriverByTopBase, setEditingDriverByTopBase] = useState({})
	const [editingBranchByTopBase, setEditingBranchByTopBase] = useState({})
	const [editingOperatorByChpp, setEditingOperatorByChpp] = useState({})
	const [editingDriverByChpp, setEditingDriverByChpp] = useState({})
	const [editingBranchByChpp, setEditingBranchByChpp] = useState({})
	const [editingOperatorByPrivatePoint, setEditingOperatorByPrivatePoint] = useState({})
	const [editingDriverByPrivatePoint, setEditingDriverByPrivatePoint] = useState({})
	const [editingBranchByPrivatePoint, setEditingBranchByPrivatePoint] = useState({})
	const [editPayloads, setEditPayloads] = useState({})

	// per-driver inline search inputs (keyed by `${topBase}_${driverId}`)
	const [employeeSearchByDriver, setEmployeeSearchByDriver] = useState({})
	const [topBaseSearchByDriver, setTopBaseSearchByDriver] = useState({})
	const [chppSearchByDriver, setChppSearchByDriver] = useState({})
	const [privatePointSearchByDriver, setPrivatePointSearchByDriver] = useState({})

	const startEdit = (kind, id, initial = {}) => {
		// kind: 'guard'|'topbase'|'operator'|'driver'|'branch', id may be composite (topBaseId:opId for operator/driver)
		if (kind === 'guard') setEditingGuard(id)
		if (kind === 'topbase') setEditingTopBase(id)
		if (kind === 'chpp') setEditingChpp(id)
		if (kind === 'privatepoint') setEditingPrivatePoint(id)
		if (kind === 'operator') setEditingOperatorByTopBase(prev => ({ ...prev, [id.topBase]: id.opId }))
		if (kind === 'driver') setEditingDriverByTopBase(prev => ({ ...prev, [id.topBase]: id.drId }))
		if (kind === 'branch') {
			const baseId = id.top_base || id.chpp || id.private_point
			const brId = id.brId
			if (id.top_base) {
				setEditingBranchByTopBase(prev => ({ ...prev, [baseId]: brId }))
			} else if (id.chpp) {
				setEditingBranchByChpp(prev => ({ ...prev, [baseId]: brId }))
			} else if (id.private_point) {
				setEditingBranchByPrivatePoint(prev => ({ ...prev, [baseId]: brId }))
			}
			setEditPayloads(prev => ({ ...prev, [`branch_${baseId}_${brId}`]: { ...initial } }))
		}
		if (kind === 'chpp-operator') setEditingOperatorByChpp(prev => ({ ...prev, [id.chpp]: id.opId }))
		if (kind === 'chpp-driver') setEditingDriverByChpp(prev => ({ ...prev, [id.chpp]: id.drId }))
		if (kind === 'chpp-branch') setEditingBranchByChpp(prev => ({ ...prev, [id.chpp]: id.brId }))
		if (kind === 'privatepoint-operator') setEditingOperatorByPrivatePoint(prev => ({ ...prev, [id.private_point]: id.opId }))
		if (kind === 'privatepoint-driver') setEditingDriverByPrivatePoint(prev => ({ ...prev, [id.private_point]: id.drId }))
		if (kind === 'privatepoint-branch') setEditingBranchByPrivatePoint(prev => ({ ...prev, [id.private_point]: id.brId }))
		setEditPayloads(prev => ({ ...prev, [`${kind}_${id.topBase || id.chpp || id.private_point || ''}_${id.opId || id.drId || id.brId || id}`]: { ...initial } }))
	}

	const toggleDriver = (topBaseId, driverId) => {
		setExpandedDriverByTopBase(prev => ({ ...prev, [topBaseId]: prev[topBaseId] === driverId ? null : driverId }))
	}

	const toggleDriverChpp = (chppId, driverId) => {
		setExpandedDriverByChpp(prev => ({ ...prev, [chppId]: prev[chppId] === driverId ? null : driverId }))
	}

	const toggleDriverPrivatePoint = (privatePointId, driverId) => {
		setExpandedDriverByPrivatePoint(prev => ({ ...prev, [privatePointId]: prev[privatePointId] === driverId ? null : driverId }))
	}

	const toggleOperator = (topBaseId, operatorId) => {
		setExpandedOperatorByTopBase(prev => ({ ...prev, [topBaseId]: prev[topBaseId] === operatorId ? null : operatorId }))
	}

	const toggleOperatorChpp = (chppId, operatorId) => {
		setExpandedOperatorByChpp(prev => ({ ...prev, [chppId]: prev[chppId] === operatorId ? null : operatorId }))
	}

	const toggleOperatorPrivatePoint = (privatePointId, operatorId) => {
		setExpandedOperatorByPrivatePoint(prev => ({ ...prev, [privatePointId]: prev[privatePointId] === operatorId ? null : operatorId }))
	}

	const cancelEdit = (kind, id) => {
		if (kind === 'guard') setEditingGuard(null)
		if (kind === 'topbase') setEditingTopBase(null)
		if (kind === 'chpp') setEditingChpp(null)
		if (kind === 'privatepoint') setEditingPrivatePoint(null)
		if (kind === 'operator') setEditingOperatorByTopBase(prev => ({ ...prev, [id.topBase]: null }))
		if (kind === 'driver') setEditingDriverByTopBase(prev => ({ ...prev, [id.topBase]: null }))
		if (kind === 'branch') {
			const baseId = id.top_base || id.chpp || id.private_point
			let brId
			if (id.top_base) {
				brId = editingBranchByTopBase[baseId]
				setEditingBranchByTopBase(prev => ({ ...prev, [baseId]: null }))
			} else if (id.chpp) {
				brId = editingBranchByChpp[baseId]
				setEditingBranchByChpp(prev => ({ ...prev, [baseId]: null }))
			} else if (id.private_point) {
				brId = editingBranchByPrivatePoint[baseId]
				setEditingBranchByPrivatePoint(prev => ({ ...prev, [baseId]: null }))
			}
			setEditPayloads(prev => { const copy = { ...prev }; delete copy[`branch_${baseId}_${brId}`]; return copy })
		}
		if (kind === 'chpp-operator') setEditingOperatorByChpp(prev => ({ ...prev, [id.chpp]: null }))
		if (kind === 'chpp-driver') setEditingDriverByChpp(prev => ({ ...prev, [id.chpp]: null }))
		if (kind === 'chpp-branch') setEditingBranchByChpp(prev => ({ ...prev, [id.chpp]: null }))
		if (kind === 'privatepoint-operator') setEditingOperatorByPrivatePoint(prev => ({ ...prev, [id.private_point]: null }))
		if (kind === 'privatepoint-driver') setEditingDriverByPrivatePoint(prev => ({ ...prev, [id.private_point]: null }))
		if (kind === 'privatepoint-branch') setEditingBranchByPrivatePoint(prev => ({ ...prev, [id.private_point]: null }))
		setEditPayloads(prev => { const copy = { ...prev }; delete copy[`${kind}_${id.topBase || id.chpp || id.private_point || ''}_${id.opId || id.drId || id.brId || id}`]; return copy })
	}

	const saveEdit = async (kind, id) => {
		const key = `${kind}_${id.topBase || id.chpp || id.private_point || ''}_${id.opId || id.drId || id}`
		const payload = editPayloads[key] || {}
		try {
			if (kind === 'guard') {
				await updateGuard(id, payload)
				await loadGuardsPage()
				setEditingGuard(null)
			}
			if (kind === 'topbase') {
				await updateTopBase(id, payload)
				await loadTopBasesPage()
				setEditingTopBase(null)
			}
			if (kind === 'chpp') {
				await updateChpp(id, payload)
				await loadChppsPage()
				setEditingChpp(null)
			}
			if (kind === 'operator') {
				// Сохраняем основные данные оператора
				const operatorData = { ...payload }
				delete operatorData.newDocuments // Убираем документы из основного payload
				
				await updateTopBaseOperator(id.opId, operatorData)
				
				// Загружаем новые документы если есть
				if (payload.newDocuments && payload.newDocuments.length > 0) {
					try {
						await uploadOperatorDocuments(id.opId, payload.newDocuments)
					} catch (docErr) {
						console.error('Failed to upload documents:', docErr)
						notifyError(docErr, 'Данные сохранены, но не удалось загрузить документы')
					}
				}
				
				await loadOperatorsByTopBasePage(id.topBase, 1)
				setEditingOperatorByTopBase(prev => ({ ...prev, [id.topBase]: null }))
			}
			if (kind === 'driver') {
				// Сохраняем основные данные водителя
				const driverData = { ...payload }
				delete driverData.newDocuments // Убираем документы из основного payload
				
				// Обрабатываем тип базы
				const baseType = driverData.base_type || 'top_base'
				delete driverData.base_type
				
				// Очищаем поля других типов баз
				if (baseType === 'top_base') {
					driverData.chpp = null
					driverData.private_point = null
				} else if (baseType === 'chpp') {
					driverData.top_base = null
					driverData.private_point = null
				} else if (baseType === 'private_point') {
					driverData.top_base = null
					driverData.chpp = null
				}
				
				await updateDriver(id.drId, driverData)
				
				// Загружаем новые документы если есть
				if (payload.newDocuments && payload.newDocuments.length > 0) {
					try {
						await uploadDriverDocuments(id.drId, payload.newDocuments)
					} catch (docErr) {
						console.error('Failed to upload documents:', docErr)
						notifyError(docErr, 'Данные сохранены, но не удалось загрузить документы')
					}
				}
				
				await loadDriversByTopBasePage(id.topBase, 1)
				setEditingDriverByTopBase(prev => ({ ...prev, [id.topBase]: null }))
			}
			if (kind === 'branch') {
				const baseId = id.top_base || id.chpp || id.private_point
				const brId = id.brId
				const data = editPayloads[`branch_${baseId}_${brId}`]
				if (data) {
					updateBranch(brId, data).then(() => {
						if (id.top_base) {
							setEditingBranchByTopBase(prev => ({ ...prev, [baseId]: null }))
						} else if (id.chpp) {
							setEditingBranchByChpp(prev => ({ ...prev, [baseId]: null }))
						} else if (id.private_point) {
							setEditingBranchByPrivatePoint(prev => ({ ...prev, [baseId]: null }))
						}
						setEditPayloads(prev => {
							const newP = { ...prev }
							delete newP[`branch_${baseId}_${brId}`]
							return newP
						})
						// reload
						if (id.top_base && expandedBranchesTopBase === baseId) {
							loadBranchesByTopBasePage(baseId, branchesPaginationByTopBase[baseId]?.page || 1)
						} else if (id.chpp && expandedBranchesChpp === baseId) {
							loadBranchesByChppPage(baseId, branchesPaginationByChpp[baseId]?.page || 1)
						} else if (id.private_point && expandedBranchesPrivatePoint === baseId) {
							loadBranchesByPrivatePointPage(baseId, branchesPaginationByPrivatePoint[baseId]?.page || 1)
						}
					}).catch(err => {
						console.error('Save edit failed', err)
						notifyError(err, 'Не удалось сохранить изменения')
					})
				}
			}
			if (kind === 'chpp-operator') {
				// Сохраняем основные данные оператора
				const operatorData = { ...payload }
				delete operatorData.newDocuments // Убираем документы из основного payload
				
				await updateChppOperator(id.opId, operatorData)
				
				// Загружаем новые документы если есть
				if (payload.newDocuments && payload.newDocuments.length > 0) {
					try {
						await uploadOperatorDocuments(id.opId, payload.newDocuments)
					} catch (docErr) {
						console.error('Failed to upload documents:', docErr)
						notifyError(docErr, 'Данные сохранены, но не удалось загрузить документы')
					}
				}
				
				await loadOperatorsByChppPage(id.chpp, 1)
				setEditingOperatorByChpp(prev => ({ ...prev, [id.chpp]: null }))
			}
			if (kind === 'chpp-driver') {
				// Сохраняем основные данные водителя
				const driverData = { ...payload }
				delete driverData.newDocuments // Убираем документы из основного payload
				
				// Обрабатываем тип базы
				const baseType = driverData.base_type || 'chpp'
				delete driverData.base_type
				
				// Очищаем поля других типов баз
				if (baseType === 'top_base') {
					driverData.chpp = null
					driverData.private_point = null
				} else if (baseType === 'chpp') {
					driverData.top_base = null
					driverData.private_point = null
				} else if (baseType === 'private_point') {
					driverData.top_base = null
					driverData.chpp = null
				}
				
				await updateDriver(id.drId, driverData)
				
				// Загружаем новые документы если есть
				if (payload.newDocuments && payload.newDocuments.length > 0) {
					try {
						await uploadDriverDocuments(id.drId, payload.newDocuments)
					} catch (docErr) {
						console.error('Failed to upload documents:', docErr)
						notifyError(docErr, 'Данные сохранены, но не удалось загрузить документы')
					}
				}
				
				await loadDriversByChppPage(id.chpp, 1)
				setEditingDriverByChpp(prev => ({ ...prev, [id.chpp]: null }))
			}
			if (kind === 'chpp-branch') {
				await updateBranch(id.brId, payload)
				await loadBranchesByChppPage(id.chpp, 1)
				setEditingBranchByChpp(prev => ({ ...prev, [id.chpp]: null }))
			}
			if (kind === 'privatepoint') {
				await updatePrivatePoint(id, payload)
				await loadPrivatePointsPage()
				setEditingPrivatePoint(null)
			}
			if (kind === 'privatepoint-operator') {
				// Сохраняем основные данные оператора
				const operatorData = { ...payload }
				delete operatorData.newDocuments // Убираем документы из основного payload
				
				await updatePrivatePointOperator(id.opId, operatorData)
				
				// Загружаем новые документы если есть
				if (payload.newDocuments && payload.newDocuments.length > 0) {
					try {
						await uploadOperatorDocuments(id.opId, payload.newDocuments)
					} catch (docErr) {
						console.error('Failed to upload documents:', docErr)
						notifyError(docErr, 'Данные сохранены, но не удалось загрузить документы')
					}
				}
				
				await loadOperatorsByPrivatePointPage(id.private_point, 1)
				setEditingOperatorByPrivatePoint(prev => ({ ...prev, [id.private_point]: null }))
			}
			if (kind === 'privatepoint-driver') {
				// Сохраняем основные данные водителя
				const driverData = { ...payload }
				delete driverData.newDocuments // Убираем документы из основного payload
				
				// Обрабатываем тип базы
				const baseType = driverData.base_type || 'private_point'
				delete driverData.base_type
				
				// Очищаем поля других типов баз
				if (baseType === 'top_base') {
					driverData.chpp = null
					driverData.private_point = null
				} else if (baseType === 'chpp') {
					driverData.top_base = null
					driverData.private_point = null
				} else if (baseType === 'private_point') {
					driverData.top_base = null
					driverData.chpp = null
				}
				
				await updateDriver(id.drId, driverData)
				
				// Загружаем новые документы если есть
				if (payload.newDocuments && payload.newDocuments.length > 0) {
					try {
						await uploadDriverDocuments(id.drId, payload.newDocuments)
					} catch (docErr) {
						console.error('Failed to upload documents:', docErr)
						notifyError(docErr, 'Данные сохранены, но не удалось загрузить документы')
					}
				}
				
				await loadDriversByPrivatePointPage(id.private_point, 1)
				setEditingDriverByPrivatePoint(prev => ({ ...prev, [id.private_point]: null }))
			}
			if (kind === 'privatepoint-branch') {
				await updateBranch(id.brId, payload)
				await loadBranchesByPrivatePointPage(id.private_point, 1)
				setEditingBranchByPrivatePoint(prev => ({ ...prev, [id.private_point]: null }))
			}
			notifySuccess('Изменения сохранены')
		} catch (err) {
			console.error('Save edit failed', err)
			notifyError(err, 'Не удалось сохранить изменения')
		}
	}

	const openCreateModal = (type, payload = {}) => {
		setModalType(type)
		setModalPayload(payload)
		setModalOpen(true)
	}

	const modalTypeNames = {
		guard: 'Охранник КПП',
		topbase: 'ТОП-База',
		operator: 'Оператор ТОП-Базы',
		driver: 'Водитель',
		chpp: 'ТЭЦ',
		'chpp-operator': 'Оператор ТЭЦ',
		'chpp-driver': 'Водитель ТЭЦ',
		privatepoint: 'Частная точка',
		'privatepoint-operator': 'Оператор соц.объекта или МСУ',
		'privatepoint-driver': 'Водитель соц.объекта или МСУ',
		branch: 'Филиал'
	}

	const closeModal = () => {
		setModalOpen(false)
		setModalType(null)
		setModalPayload({})
	}

	const loadEmployees = async () => {
		try {
			let allEmployees = []
			let page = 1
			let hasMore = true
			const maxPages = 100 // Safety limit
			
			while (hasMore && page <= maxPages) {
				const res = await getAllEmployees({ params: { page, page_size: 50 } })
				const data = res?.data || res
				if (data && Array.isArray(data.results)) {
					allEmployees = [...allEmployees, ...data.results]
					hasMore = !!data.next
					page++
				} else {
					// Old format without pagination
					allEmployees = Array.isArray(data) ? data : []
					hasMore = false
				}
			}
			
			setEmployees(allEmployees)
		} catch (err) {
			console.error('Failed to load employees', err)
		}
	}

	// Debounced search - reload data from server when filter changes
	React.useEffect(() => {
		if (open !== 'kpp') return
		const timer = setTimeout(() => {
			loadGuardsPage(1, guardsFilter)
		}, 300)
		return () => clearTimeout(timer)
	}, [guardsFilter])

	React.useEffect(() => {
		if (open !== 'top') return
		const timer = setTimeout(() => {
			loadTopBasesPage(1, topBasesFilter)
		}, 300)
		return () => clearTimeout(timer)
	}, [topBasesFilter])

	React.useEffect(() => {
		if (open !== 'chpp') return
		const timer = setTimeout(() => {
			loadChppsPage(1, chppsFilter)
		}, 300)
		return () => clearTimeout(timer)
	}, [chppsFilter])

	React.useEffect(() => {
		if (open !== 'private') return
		const timer = setTimeout(() => {
			loadPrivatePointsPage(1, privatePointsFilter)
		}, 300)
		return () => clearTimeout(timer)
	}, [privatePointsFilter])

	React.useEffect(() => {
		if (open !== 'drivers') return
		const timer = setTimeout(() => {
			loadDriversPage(1, driversFilter)
		}, 300)
		return () => clearTimeout(timer)
	}, [driversFilter])

	// Debounced search for drivers by TopBase
	React.useEffect(() => {
		Object.keys(driversFilterByTopBase).forEach(topBaseId => {
			const searchQuery = driversFilterByTopBase[topBaseId]
			if (searchQuery !== undefined && expandedDriversTopBase === parseInt(topBaseId)) {
				const timer = setTimeout(() => {
					loadDriversByTopBasePage(topBaseId, 1, searchQuery)
				}, 300)
				return () => clearTimeout(timer)
			}
		})
	}, [driversFilterByTopBase, expandedDriversTopBase])

	// Debounced search for drivers by CHPP
	React.useEffect(() => {
		Object.keys(driversFilterByChpp).forEach(chppId => {
			const searchQuery = driversFilterByChpp[chppId]
			if (searchQuery !== undefined && expandedDriversChpp === parseInt(chppId)) {
				const timer = setTimeout(() => {
					loadDriversByChppPage(chppId, 1, searchQuery)
				}, 300)
				return () => clearTimeout(timer)
			}
		})
	}, [driversFilterByChpp, expandedDriversChpp])

	// Debounced search for drivers by PrivatePoint
	React.useEffect(() => {
		Object.keys(driversFilterByPrivatePoint).forEach(privatePointId => {
			const searchQuery = driversFilterByPrivatePoint[privatePointId]
			if (searchQuery !== undefined && expandedDriversPrivatePoint === parseInt(privatePointId)) {
				const timer = setTimeout(() => {
					loadDriversByPrivatePointPage(privatePointId, 1, searchQuery)
				}, 300)
				return () => clearTimeout(timer)
			}
		})
	}, [driversFilterByPrivatePoint, expandedDriversPrivatePoint])

	const handleCopyUid = async (uid) => {
		if (!uid) return
		try {
			if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(uid)
			} else {
				// fallback
				const ta = document.createElement('textarea')
				ta.value = uid
				document.body.appendChild(ta)
				ta.select()
				document.execCommand('copy')
				ta.remove()
			}
			setCopiedUid(uid)
			setTimeout(() => setCopiedUid(null), 2000)
		} catch (err) {
			console.error('Copy failed', err)
		}
	}

	const handleDownloadQr = (url, filename) => {
		if (!url) return
		const link = document.createElement('a')
		link.href = url
		link.download = filename || 'qrcode.png'
		document.body.appendChild(link)
		link.click()
		link.remove()
	}

	// helpers to print / download a driver's pass (passkk image + overlays)
	// A4 landscape HTML for print. Uses pixel coordinates matching 96dpi reference; browsers convert to print scale.
	const getPassHtml = (d, baseType, baseName) => {
		let qrSrc = (d.qrcode_img && d.qrcode_img.url) ? d.qrcode_img.url : d.qrcode_img || ''
		
		// Если QR-кода нет, но есть qrcode_scr или uid - генерируем QR-код на лету
		if (!qrSrc && (d.qrcode_scr || d.uid)) {
			const qrData = d.qrcode_scr || d.uid
			// Используем публичный API для генерации QR-кода
			qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(qrData)}`
		}
		
		const vehicle = d.vehicle_number || ''
		const tbName = baseName || ''
		const bt = baseType || ''
		// A4 landscape at 96dpi approx: 1122 x 793 px (but browsers scale for print). We'll set exact positions with absolute px offsets as requested.
		return `<!doctype html><html><head><meta charset="utf-8"><title>${d.vehicle_number || d.id}</title><style>
		@page { size: A4 landscape; margin: 0 }
		html,body{height:100%;margin:0;padding:0}
		body{display:flex;align-items:center;justify-content:center;background:#fff}
		.container{position:relative;width:1122px;height:793px;margin:0 auto}
		.bg{position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover}
		.qr{position:absolute;width:379px;height:379px;right:43px;bottom:133px;object-fit:contain;background:#fff;padding:10px;border:2px solid #e0e0e0}
		.qr-fallback{position:absolute;width:379px;height:379px;right:43px;bottom:133px;background:#f0f0f0;display:none;align-items:center;justify-content:center;color:#999;font-size:18px;flex-direction:column;padding:10px;border:2px solid #e0e0e0}
			.basetype{position:absolute;left:50%;top:49px;transform:translateX(-50%);font-family: system-ui, auto; font-size:60px; line-height:56px; letter-spacing:0em; color: black; font-weight:700; text-align:center}
			.tbname{position:absolute;left:189px;bottom:220px;font-family: system-ui, auto; font-size:40px; line-height:56px; letter-spacing:0em; color: rgb(4,92,156); font-weight:700; text-transform:none; width: 500px;}
			.vehicle{position:absolute;left:189px;bottom:132px;font-family: system-ui, auto; text-align:left;font-size:51px;font-weight:500;font-style:normal;color:rgb(219 0 0);font-kerning:normal;text-decoration:none}
		@media print { .qr, .qr-fallback { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
		</style></head><body>
		<div class="container">
			<img class="bg" src="${passkk}" alt="pass" />
			${qrSrc ? `<img class="qr" src="${qrSrc}" alt="qr" onload="console.log('QR успешно загружен'); this.style.display='block';" onerror="console.error('QR не загрузился, показываю fallback'); this.style.display='none'; document.querySelector('.qr-fallback').style.display='flex';" style="display:block;" />
			<div class="qr-fallback">
				<div>QR-код</div>
				<div style="font-size:12px;margin-top:8px;word-break:break-all;max-width:90%;text-align:center">${d.qrcode_scr || d.uid || ''}</div>
			</div>` : `<div class="qr-fallback" style="display:flex;">
				<div>QR-код недоступен</div>
			</div>`}
			<div class="basetype">${bt}</div>
			<div class="tbname">${tbName}</div>
			<div class="vehicle">${vehicle}</div>
		</div>
		</body></html>`
	}

	const printDriverPass = (d, baseType, baseName) => {
		try {
			const html = getPassHtml(d, baseType, baseName)
			const w = window.open('', '_blank')
			if (!w) return notifyError(new Error('Popup blocked'), 'Не удалось открыть окно печати')
			w.document.open()
			w.document.write(html)
			w.document.close()
			
			// Ждем полной загрузки всех изображений перед печатью
			const checkImagesLoaded = () => {
				const imgs = w.document.getElementsByTagName('img')
				let allLoaded = true
				let qrLoaded = false
				
				for (let i = 0; i < imgs.length; i++) {
					if (imgs[i].className === 'qr') {
						if (!imgs[i].complete || imgs[i].naturalHeight === 0) {
							allLoaded = false
						} else {
							qrLoaded = true
						}
					} else if (!imgs[i].complete) {
						allLoaded = false
					}
				}
				
				if (allLoaded && qrLoaded) {
					console.log('All images loaded, printing...')
					w.focus()
					w.print()
				} else {
					console.log('Waiting for images to load...')
				}
			}
			
			// Проверяем загрузку несколько раз с увеличивающимися интервалами
			setTimeout(() => checkImagesLoaded(), 500)
			setTimeout(() => checkImagesLoaded(), 1000)
			setTimeout(() => checkImagesLoaded(), 2000)
			setTimeout(() => { w.focus(); w.print(); }, 3000) // Финальная попытка через 3 секунды в любом случае
		} catch (err) {
			console.error('Print failed', err)
			notifyError(err, 'Не удалось распечатать пропуск')
		}
	}

	// Robust image loader: try fetch->blob->createImageBitmap (preferred) to avoid CORS-tainted canvas.
	// Falls back to loading Image normally when fetch is not allowed.
	const loadImage = async (src) => {
		if (!src) return null
		try {
			// Try fetch first to get a blob (this avoids cross-origin taint if the server allows it).
			const res = await fetch(src, { mode: 'cors' })
			if (!res.ok) throw new Error(`Failed to fetch image: ${res.status}`)
			const blob = await res.blob()
			// Try createImageBitmap for better performance when available
			if (window.createImageBitmap) {
				try {
					const bitmap = await createImageBitmap(blob)
					return bitmap
				} catch (e) {
					// fallback to Image element below
				}
			}
			// Fallback: create an object URL and Image
			const url = URL.createObjectURL(blob)
			const img = await new Promise((resolve, reject) => {
				const i = new Image()
				i.onload = () => { resolve(i); URL.revokeObjectURL(url) }
				i.onerror = (err) => { URL.revokeObjectURL(url); reject(err) }
				i.src = url
			})
			return img
		} catch (err) {
			// Final fallback: try to load directly via Image (may taint canvas)
			return new Promise((resolve, reject) => {
				try {
					const i = new Image()
					i.crossOrigin = 'anonymous'
					i.onload = () => resolve(i)
					i.onerror = (e) => reject(e)
					i.src = src
				} catch (e) { reject(e) }
			})
		}
	}

	const downloadDriverPass = async (d, baseType, baseName) => {
		// Try multiple DPI levels to handle memory/size constraints
		const dpiCandidates = [300, 150, 96]
		const mmToInch = mm => mm / 25.4

		for (const DPI of dpiCandidates) {
			try {
				const widthPx = Math.round(297 * mmToInch * DPI)
				const heightPx = Math.round(210 * mmToInch * DPI)
				const canvas = document.createElement('canvas')
				canvas.width = widthPx
				canvas.height = heightPx
				const ctx = canvas.getContext('2d')
				// draw white background
				ctx.fillStyle = '#fff'
				ctx.fillRect(0, 0, widthPx, heightPx)

				// Load images via fetch->blob where possible to avoid CORS taint
				const bgImg = await loadImage(passkk).catch(() => null)
				let qrSrc = (d.qrcode_img && d.qrcode_img.url) ? d.qrcode_img.url : d.qrcode_img || ''
				
				// Если QR-кода нет, но есть qrcode_scr или uid - генерируем QR-код на лету
				if (!qrSrc && (d.qrcode_scr || d.uid)) {
					const qrData = d.qrcode_scr || d.uid
					qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(qrData)}`
				}
				
				const qrImg = qrSrc ? await loadImage(qrSrc).catch(() => null) : null

				// Scale CSS px -> canvas px
				const scale = DPI / 96
				// Draw background: if we have an ImageBitmap (createImageBitmap) or Image element, draw appropriately
				try {
					if (bgImg) ctx.drawImage(bgImg, 0, 0, widthPx, heightPx)
				} catch (e) {
					// ignore draw errors and continue
				}

				const qrSizeCss = 379
				const qrSize = Math.round(qrSizeCss * scale)
				const qrRightCss = 75
				const qrBottomCss = 144
				const qrX = widthPx - Math.round(qrRightCss * scale) - qrSize
				const qrY = heightPx - Math.round(qrBottomCss * scale) - qrSize
				if (qrImg) {
					try { ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize) } catch (e) { }
				}

				const tbLeftCss = 189
				const tbBottomCss = 265
				const tbX = Math.round(tbLeftCss * scale)
				const tbY = heightPx - Math.round(tbBottomCss * scale)
				const vehicleLeftCss = 189
				const vehicleBottomCss = 132
				const vehicleX = Math.round(vehicleLeftCss * scale)
				const vehicleY = heightPx - Math.round(vehicleBottomCss * scale)

				const topBaseFontCss = 51.999
				const vehicleFontCss = 16
				const baseTypeFontCss = 60
				const topBaseFontSize = Math.round(topBaseFontCss * scale)
				const vehicleFontSize = Math.round(vehicleFontCss * scale)
				const baseTypeFontSize = Math.round(baseTypeFontCss * scale)
				const baseTypeY = baseTypeFontSize

				ctx.fillStyle = 'black'
				ctx.textBaseline = 'alphabetic'
				ctx.textAlign = 'center'
				ctx.font = `${baseTypeFontSize}px Arial`
				try { ctx.fillText(baseType || '', widthPx / 2, baseTypeY) } catch (e) { }

				ctx.textAlign = 'left'
				ctx.font = `${topBaseFontSize}px Arial`
				try { ctx.fillText(baseName || '', tbX, tbY) } catch (e) { }

				// Export canvas to blob (preferring toBlob). Wrap in Promise for async/await.
				const blob = await new Promise((resolve) => {
					try {
						if (canvas.toBlob) {
							canvas.toBlob((b) => resolve(b), 'image/png')
						} else {
							resolve(null)
						}
					} catch (e) {
						resolve(null)
					}
				})

				// If blob is valid and has size, download it
				if (blob && blob.size && blob.size > 0) {
					const objUrl = URL.createObjectURL(blob)
					const a = document.createElement('a')
					a.href = objUrl
					a.download = `${d.vehicle_number || d.id}.png`
					document.body.appendChild(a)
					a.click()
					a.remove()
					setTimeout(() => URL.revokeObjectURL(objUrl), 1000)
					return
				}

				// Fallback: try toDataURL
				try {
					const url = canvas.toDataURL('image/png')
					if (url && url.indexOf('data:image') === 0) {
						const a = document.createElement('a')
						a.href = url
						a.download = `${d.vehicle_number || d.id}.png`
						document.body.appendChild(a)
						a.click()
						a.remove()
						return
					}
				} catch (e) {
					// continue to next DPI candidate
				}

				// If we reach here, this DPI failed — try next (smaller) DPI
			} catch (err) {
				// try next DPI
			}
		}

		// If all DPI candidates failed
		notifyError(new Error('Не удалось сформировать изображение пропуска — возможно CORS или ограничение размера изображения'))
	}

	const processPaged = (res) => {
		const data = res?.data || res
		if (data && typeof data === 'object' && Array.isArray(data.results)) {
			return { items: data.results, pagination: { count: data.count, next: data.next, previous: data.previous } }
		}
		return { items: Array.isArray(data) ? data : [], pagination: {} }
	}

		// notification helpers
		const notifySuccess = (message = 'Успешно') => {
			setNotify({ isOpen: true, message, type: 'success', sound: 'success' })
		}

		const notifyError = (err, defaultMsg = 'Ошибка') => {
			let message = defaultMsg
			try {
				if (err && err.response && err.response.data) {
					const data = err.response.data
					// Prefer field-level validation messages (e.g. { vehicle_number: ["..."] })
					if (typeof data === 'string') message = data
					else if (data.detail) message = data.detail
					else if (data.message) message = data.message
					else if (data.non_field_errors) message = (Array.isArray(data.non_field_errors) ? data.non_field_errors.join('; ') : String(data.non_field_errors))
					else if (typeof data === 'object') {
						// find first field message
						for (const key of Object.keys(data)) {
							const val = data[key]
							if (!val) continue
							if (Array.isArray(val) && val.length) { message = String(val[0]); break }
							if (typeof val === 'string') { message = val; break }
						}
						if (message === defaultMsg) message = JSON.stringify(data)
					} else message = JSON.stringify(data)
				} else if (err && err.message) {
					message = err.message
				}
			} catch (e) {
				message = defaultMsg
			}
			setNotify({ isOpen: true, message: String(message), type: 'error', sound: 'error' })
		}

	// loaders
	const loadGuards = async () => {
		try {
			const res = await getGuards()
			const { items, pagination } = processPaged(res)
			setGuards(items)
			setGuardsPagination({ ...pagination, page: 1 })
		} catch (err) {
			console.error('Failed to load guards', err)
			notifyError(err, 'Не удалось загрузить охранников')
		}
	}

	const loadTopBases = async () => {
		try {
			const res = await getTopBases()
			const { items, pagination } = processPaged(res)
			setTopBases(items)
			setTopBasesPagination({ ...pagination, page: 1 })
		} catch (err) {
			console.error('Failed to load top bases', err)
			notifyError(err, 'Не удалось загрузить ТОП-базы')
		}
	}

	const loadChpps = async () => {
		try {
			const res = await getChpps()
			const { items, pagination } = processPaged(res)
			setChpps(items)
			setChppsPagination({ ...pagination, page: 1 })
		} catch (err) {
			console.error('Failed to load chpps', err)
			notifyError(err, 'Не удалось загрузить ТЭЦ')
		}
	}

	const loadAllPrivatePoints = async () => {
		try {
			const res = await getPrivatePoints()
			const { items } = processPaged(res)
			setAllPrivatePoints(items)
		} catch (err) {
			console.error('Failed to load all private points', err)
		}
	}

	const loadDrivers = async () => {
		try {
			const res = await getDrivers()
			const { items, pagination } = processPaged(res)
			setDrivers(items)
			setDriversPagination({ ...pagination, page: 1 })
		} catch (err) {
			console.error('Failed to load drivers', err)
			notifyError(err, 'Не удалось загрузить водителей')
		}
	}

	// loaders with page support
	const loadDriversPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getDrivers(params)
			const { items, pagination } = processPaged(res)
			setDrivers(items)
			setDriversPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load drivers page', err) }
	}

	const loadGuardsPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getGuards(params)
			const { items, pagination } = processPaged(res)
			setGuards(items)
			setGuardsPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load guards page', err) }
	}

	const loadTopBasesPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getTopBases(params)
			const { items, pagination } = processPaged(res)
			setTopBases(items)
			setTopBasesPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load top bases page', err) }
	}

	const loadChppsPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getChpps(params)
			const { items, pagination } = processPaged(res)
			setChpps(items)
			setChppsPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load chpps page', err) }
	}

	const loadOperators = async (topBaseId) => {
		return loadOperatorsByTopBasePage(topBaseId, 1)
	}

	const loadOperatorsByTopBasePage = async (topBaseId, page = 1, search = '') => {
		try {
			const params = { top_base: topBaseId, page }
			if (search) params.search = search
			const res = await getTopBaseOperators(params)
			const { items, pagination } = processPaged(res)
			setOperatorsByTopBase((prev) => ({ ...prev, [topBaseId]: items }))
			setOperatorsPaginationByTopBase((prev) => ({ ...prev, [topBaseId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load operators for top base', topBaseId, err)
			notifyError(err, 'Не удалось загрузить операторов для ТОП-базы')
		}
	}

	const loadDriversByTopBase = async (topBaseId) => {
		return loadDriversByTopBasePage(topBaseId, 1)
	}

	const loadDriversByTopBasePage = async (topBaseId, page = 1, search = '') => {
		try {
			const params = { top_base: topBaseId, page }
			if (search) params.search = search
			const res = await getDrivers(params)
			const { items, pagination } = processPaged(res)
			setDriversByTopBase((prev) => ({ ...prev, [topBaseId]: items }))
			setDriversPaginationByTopBase((prev) => ({ ...prev, [topBaseId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load drivers for top base', topBaseId, err)
			notifyError(err, 'Не удалось загрузить водителей для ТОП-базы')
		}
	}

	const loadBranchesByTopBasePage = async (topBaseId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getTopBaseBranches(topBaseId, params)
			const { items, pagination } = processPaged(res)
			setBranchesByTopBase((prev) => ({ ...prev, [topBaseId]: items }))
			setBranchesPaginationByTopBase((prev) => ({ ...prev, [topBaseId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load branches for top base', topBaseId, err)
			notifyError(err, 'Не удалось загрузить филиалы для ТОП-базы')
		}
	}

	const loadOperatorsByChppPage = async (chppId, page = 1, search = '') => {
		try {
			const params = { chpp: chppId, page }
			if (search) params.search = search
			const res = await getChppOperators(params)
			const { items, pagination } = processPaged(res)
			setOperatorsByChpp((prev) => ({ ...prev, [chppId]: items }))
			setOperatorsPaginationByChpp((prev) => ({ ...prev, [chppId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load operators for chpp', chppId, err)
			notifyError(err, 'Не удалось загрузить операторов для ТЭЦ')
		}
	}

	const loadDriversByChpp = async (chppId) => {
		return loadDriversByChppPage(chppId, 1)
	}

	const loadDriversByChppPage = async (chppId, page = 1, search = '') => {
		try {
			const params = { chpp: chppId, page }
			if (search) params.search = search
			const res = await getDrivers(params)
			const { items, pagination } = processPaged(res)
			setDriversByChpp((prev) => ({ ...prev, [chppId]: items }))
			setDriversPaginationByChpp((prev) => ({ ...prev, [chppId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load drivers for chpp', chppId, err)
			notifyError(err, 'Не удалось загрузить водителей для ТЭЦ')
		}
	}

	const loadBranchesByChppPage = async (chppId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getChppBranches(chppId, params)
			const { items, pagination } = processPaged(res)
			setBranchesByChpp((prev) => ({ ...prev, [chppId]: items }))
			setBranchesPaginationByChpp((prev) => ({ ...prev, [chppId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load branches for chpp', chppId, err)
			notifyError(err, 'Не удалось загрузить филиалы для ТЭЦ')
		}
	}

	const loadPrivatePointsPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getPrivatePoints(params)
			const { items, pagination } = processPaged(res)
			setPrivatePoints(items)
			setPrivatePointsPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load private points page', err) }
	}

	const loadOperatorsByPrivatePointPage = async (privatePointId, page = 1, search = '') => {
		try {
			const params = { private_point: privatePointId, page }
			if (search) params.search = search
			const res = await getPrivatePointOperators(params)
			const { items, pagination } = processPaged(res)
			setOperatorsByPrivatePoint((prev) => ({ ...prev, [privatePointId]: items }))
			setOperatorsPaginationByPrivatePoint((prev) => ({ ...prev, [privatePointId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load operators for private point', privatePointId, err)
			notifyError(err, 'Не удалось загрузить операторов для соц.объекта или МСУ')
		}
	}

	const loadDriversByPrivatePoint = async (privatePointId) => {
		return loadDriversByPrivatePointPage(privatePointId, 1)
	}

	const loadDriversByPrivatePointPage = async (privatePointId, page = 1, search = '') => {
		try {
			const params = { private_point: privatePointId, page }
			if (search) params.search = search
			const res = await getDrivers(params)
			const { items, pagination } = processPaged(res)
			setDriversByPrivatePoint((prev) => ({ ...prev, [privatePointId]: items }))
			setDriversPaginationByPrivatePoint((prev) => ({ ...prev, [privatePointId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load drivers for private point', privatePointId, err)
			notifyError(err, 'Не удалось загрузить водителей для соц.объекта или МСУ')
		}
	}

	const loadBranchesByPrivatePointPage = async (privatePointId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getPrivatePointBranches(privatePointId, params)
			const { items, pagination } = processPaged(res)
			setBranchesByPrivatePoint((prev) => ({ ...prev, [privatePointId]: items }))
			setBranchesPaginationByPrivatePoint((prev) => ({ ...prev, [privatePointId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load branches for private point', privatePointId, err)
			notifyError(err, 'Не удалось загрузить филиалы для соц.объекта или МСУ')
		}
	}

	const loadAllBranches = async () => {
		try {
			let allItems = []
			let page = 1
			let hasMore = true
			
			// Загружаем все страницы филиалов
			while (hasMore) {
				const res = await getBranches({ page, page_size: 100 })
				const { items, pagination } = processPaged(res)
				allItems = [...allItems, ...items]
				
				// Проверяем, есть ли следующая страница
				if (pagination.next) {
					page++
				} else {
					hasMore = false
				}
			}
			
			setAllBranches(allItems)
		} catch (err) {
			console.error('Failed to load all branches', err)
			notifyError(err, 'Не удалось загрузить все филиалы')
		}
	}

	// watch panel open changes
	React.useEffect(() => {
		if (open === 'kpp') {
			setGuardsFilter('')
			loadGuardsPage(1, '')
		}
		if (open === 'top') {
			setTopBasesFilter('')
			loadTopBasesPage(1, '')
			loadAllBranches()
			// Загружаем все базы для редактирования водителей
			if (chpps.length === 0) {
				getChpps({ page_size: 100 }).then(res => {
					setChpps(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all chpps', err))
			}
			if (privatePoints.length === 0) {
				getPrivatePoints({ page_size: 100 }).then(res => {
					setPrivatePoints(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all private points', err))
			}
		}
		if (open === 'chpp') {
			setChppsFilter('')
			loadChppsPage(1, '')
			loadAllBranches()
			// Загружаем все базы для редактирования водителей
			if (topBases.length === 0) {
				getTopBases({ page_size: 100 }).then(res => {
					setTopBases(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all top bases', err))
			}
			if (privatePoints.length === 0) {
				getPrivatePoints({ page_size: 100 }).then(res => {
					setPrivatePoints(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all private points', err))
			}
		}
		if (open === 'private') {
			setPrivatePointsFilter('')
			loadPrivatePointsPage(1, '')
			loadAllPrivatePoints()
			loadAllBranches()
			// Загружаем все базы для редактирования водителей
			if (topBases.length === 0) {
				getTopBases({ page_size: 100 }).then(res => {
					setTopBases(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all top bases', err))
			}
			if (chpps.length === 0) {
				getChpps({ page_size: 100 }).then(res => {
					setChpps(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all chpps', err))
			}
		}
		if (open === 'drivers') {
			setDriversFilter('')
			loadDriversPage(1, '')
			// Загружаем все базы для отображения в списке водителей
			if (topBases.length === 0) {
				getTopBases({ page_size: 100 }).then(res => {
					setTopBases(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all top bases', err))
			}
			if (chpps.length === 0) {
				getChpps({ page_size: 100 }).then(res => {
					setChpps(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all chpps', err))
			}
			if (privatePoints.length === 0) {
				getPrivatePoints({ page_size: 100 }).then(res => {
					setPrivatePoints(res.data.results || res.data || [])
				}).catch(err => console.error('Failed to load all private points', err))
			}
		}
	}, [open])

	// load employees when opening a create modal that needs employee selection
	React.useEffect(() => {
		if (modalOpen && ['guard', 'operator', 'driver', 'chpp-operator', 'chpp-driver', 'privatepoint-operator', 'privatepoint-driver'].includes(modalType) && employees.length === 0) {
			loadEmployees()
		}
	}, [modalOpen, modalType])


	return (
		<Layout>
			<div className={styles.wrapper}>
				<div className={styles.adminPanel}>
					{[
						{ key: 'kpp',            icon: '🛡️',  label: 'Охрана КПП' },
						{ key: 'top',            icon: '🏭',  label: 'ТОП-Базы' },
						{ key: 'chpp',           icon: '⚡',  label: 'ТЭЦ' },
						{ key: 'private',        icon: '🏗️',  label: 'Соц. Объекты и МСУ' },
						{ key: 'loads',          icon: '🚛',  label: 'Погрузки' },
						{ key: 'drivers',        icon: '👤',  label: 'Водители' },
						{ key: 'driver-checked', icon: '✅',  label: 'Подтверждения' },
						{ key: 'base-requests',  icon: '📋',  label: 'Заявки на базы' },
						{ key: 'komursvyaz',     icon: '💬',  label: 'КомурСвязь' },
					].map(({ key, icon, label }) => (
						<button
							key={key}
							className={`${styles.navTab} ${open === key ? styles.navTabActive : ''}`}
							onClick={() => toggle(key)}
						>
							<span className={styles.navTabIcon}>{icon}</span>
							{label}
							{open === key && <span className={styles.navTabBadge}>▲</span>}
						</button>
					))}
				</div>

				{/* panels container - always rendered below the buttons */}
				<div className={styles.panelsContainer}>
					{open === 'kpp' && (
						<GuardsPanel
						  guardsFilter={guardsFilter}
						  setGuardsFilter={setGuardsFilter}
						  filteredGuards={guards}
						  guardsPagination={guardsPagination}
						  loadGuardsPage={loadGuardsPage}
						  openCreateModal={openCreateModal}
						  startEdit={startEdit}
						  editingGuard={editingGuard}
						  editPayloads={editPayloads}
						  setEditPayloads={setEditPayloads}
						  saveEdit={saveEdit}
						  cancelEdit={cancelEdit}
						/>
					)}

					{open === 'top' && (
						<>
							<TopBasesPanel
							  topBasesFilter={topBasesFilter}
							  setTopBasesFilter={setTopBasesFilter}
							  filteredTopBases={topBases}
							  topBasesPagination={topBasesPagination}
							  loadTopBasesPage={loadTopBasesPage}
							  openCreateModal={openCreateModal}
							  startEdit={startEdit}
							  editingTopBase={editingTopBase}
							  editPayloads={editPayloads}
							  setEditPayloads={setEditPayloads}
							  saveEdit={saveEdit}
							  cancelEdit={cancelEdit}
							  expandedTopBase={expandedTopBase}
							  setExpandedTopBase={setExpandedTopBase}
							  expandedOperatorsTopBase={expandedOperatorsTopBase}
							  setExpandedOperatorsTopBase={setExpandedOperatorsTopBase}
							  expandedDriversTopBase={expandedDriversTopBase}
							  setExpandedDriversTopBase={setExpandedDriversTopBase}
							  expandedBranchesTopBase={expandedBranchesTopBase}
							  setExpandedBranchesTopBase={setExpandedBranchesTopBase}
							  loadOperatorsByTopBasePage={loadOperatorsByTopBasePage}
							  loadDriversByTopBasePage={loadDriversByTopBasePage}
							  loadBranchesByTopBasePage={loadBranchesByTopBasePage}
							  operatorsByTopBase={operatorsByTopBase}
							  driversByTopBase={driversByTopBase}
							  branchesByTopBase={branchesByTopBase}
							  operatorsPaginationByTopBase={operatorsPaginationByTopBase}
							  driversPaginationByTopBase={driversPaginationByTopBase}
							  branchesPaginationByTopBase={branchesPaginationByTopBase}
							  operatorsFilterByTopBase={operatorsFilterByTopBase}
							  driversFilterByTopBase={driversFilterByTopBase}
							  branchesFilterByTopBase={branchesFilterByTopBase}
							  setOperatorsFilterByTopBase={setOperatorsFilterByTopBase}
							  setDriversFilterByTopBase={setDriversFilterByTopBase}
							  setBranchesFilterByTopBase={setBranchesFilterByTopBase}
							  employees={employees}
							  editingOperatorByTopBase={editingOperatorByTopBase}
							  editingDriverByTopBase={editingDriverByTopBase}
							  editingBranchByTopBase={editingBranchByTopBase}
							  startEditOperator={startEdit}
							  startEditDriver={startEdit}
							  startEditBranch={startEdit}
							  saveEditOperator={saveEdit}
							  saveEditDriver={saveEdit}
							  saveEditBranch={saveEdit}
							  cancelEditOperator={cancelEdit}
							  cancelEditDriver={cancelEdit}
							  cancelEditBranch={cancelEdit}
							  loadOperators={loadOperators}
							  loadDriversByTopBase={loadDriversByTopBase}
							  expandedDriverByTopBase={expandedDriverByTopBase}
							  toggleDriver={toggleDriver}
							  expandedOperatorByTopBase={expandedOperatorByTopBase}
							  toggleOperator={toggleOperator}
							  printDriverPass={printDriverPass}
							  downloadDriverPass={downloadDriverPass}
							  topBases={topBases}
							  chpps={chpps}
							  privatePoints={privatePoints}
							/>
							<TopBasesMapView branches={allBranches} topBases={topBases} />
						</>
					)}

				{open === 'chpp' && (
					<>
						<ChppsPanel
						  chppsFilter={chppsFilter}
						  setChppsFilter={setChppsFilter}
						  filteredChpps={chpps}
						  chppsPagination={chppsPagination}
						  loadChppsPage={loadChppsPage}
						  openCreateModal={openCreateModal}
						  startEdit={startEdit}
						  editingChpp={editingChpp}
						  editPayloads={editPayloads}
						  setEditPayloads={setEditPayloads}
						  saveEdit={saveEdit}
						  cancelEdit={cancelEdit}
						  expandedChpp={expandedChpp}
						  setExpandedChpp={setExpandedChpp}
						  expandedOperatorsChpp={expandedOperatorsChpp}
						  setExpandedOperatorsChpp={setExpandedOperatorsChpp}
						  expandedDriversChpp={expandedDriversChpp}
						  setExpandedDriversChpp={setExpandedDriversChpp}
						  expandedBranchesChpp={expandedBranchesChpp}
						  setExpandedBranchesChpp={setExpandedBranchesChpp}
						  loadOperatorsByChppPage={loadOperatorsByChppPage}
						  loadDriversByChppPage={loadDriversByChppPage}
						  loadBranchesByChppPage={loadBranchesByChppPage}
						  operatorsByChpp={operatorsByChpp}
						  driversByChpp={driversByChpp}
						  branchesByChpp={branchesByChpp}
						  operatorsPaginationByChpp={operatorsPaginationByChpp}
						  driversPaginationByChpp={driversPaginationByChpp}
						  branchesPaginationByChpp={branchesPaginationByChpp}
						  operatorsFilterByChpp={operatorsFilterByChpp}
						  driversFilterByChpp={driversFilterByChpp}
						  branchesFilterByChpp={branchesFilterByChpp}
						  setOperatorsFilterByChpp={setOperatorsFilterByChpp}
						  setDriversFilterByChpp={setDriversFilterByChpp}
						  setBranchesFilterByChpp={setBranchesFilterByChpp}
						  employees={employees}
						  editingOperatorByChpp={editingOperatorByChpp}
						  editingDriverByChpp={editingDriverByChpp}
						  editingBranchByChpp={editingBranchByChpp}
						  startEditOperator={startEdit}
						  startEditDriver={startEdit}
						  startEditBranch={startEdit}
						  saveEditOperator={saveEdit}
						  saveEditDriver={saveEdit}
						  saveEditBranch={saveEdit}
						  cancelEditOperator={cancelEdit}
						  cancelEditDriver={cancelEdit}
						  cancelEditBranch={cancelEdit}
						  
						  loadOperators={() => {}}
						  loadDriversByChpp={loadDriversByChpp}
						  expandedDriverByChpp={expandedDriverByChpp}
						  toggleDriver={toggleDriverChpp}
						  expandedOperatorByChpp={expandedOperatorByChpp}
						  toggleOperatorChpp={toggleOperatorChpp}
						  printDriverPass={printDriverPass}
					  downloadDriverPass={downloadDriverPass}
					  chpps={chpps}
					  topBases={topBases}
					  privatePoints={privatePoints}
					/>
					<ChppsMapView chpps={chpps} branches={allBranches} />
				</>
				)}

				{open === 'loads' && (
					<LoadsPanel />
				)}

				{open === 'private' && (
					<>
						<PrivatePointsPanel
						  privatePointsFilter={privatePointsFilter}
						  setPrivatePointsFilter={setPrivatePointsFilter}
						  filteredPrivatePoints={privatePoints}
						  privatePointsPagination={privatePointsPagination}
						  loadPrivatePointsPage={loadPrivatePointsPage}
						  openCreateModal={openCreateModal}
						  startEdit={startEdit}
						  editingPrivatePoint={editingPrivatePoint}
						  editPayloads={editPayloads}
						  setEditPayloads={setEditPayloads}
						  saveEdit={saveEdit}
						  cancelEdit={cancelEdit}
						  expandedPrivatePoint={expandedPrivatePoint}
						  setExpandedPrivatePoint={setExpandedPrivatePoint}
						  expandedOperatorsPrivatePoint={expandedOperatorsPrivatePoint}
						  setExpandedOperatorsPrivatePoint={setExpandedOperatorsPrivatePoint}
						  expandedDriversPrivatePoint={expandedDriversPrivatePoint}
						  setExpandedDriversPrivatePoint={setExpandedDriversPrivatePoint}
						  expandedBranchesPrivatePoint={expandedBranchesPrivatePoint}
						  setExpandedBranchesPrivatePoint={setExpandedBranchesPrivatePoint}
						  loadOperatorsByPrivatePointPage={loadOperatorsByPrivatePointPage}
						  loadDriversByPrivatePointPage={loadDriversByPrivatePointPage}
						  loadBranchesByPrivatePointPage={loadBranchesByPrivatePointPage}
						  operatorsByPrivatePoint={operatorsByPrivatePoint}
						  driversByPrivatePoint={driversByPrivatePoint}
						  branchesByPrivatePoint={branchesByPrivatePoint}
						  operatorsPaginationByPrivatePoint={operatorsPaginationByPrivatePoint}
						  driversPaginationByPrivatePoint={driversPaginationByPrivatePoint}
						  branchesPaginationByPrivatePoint={branchesPaginationByPrivatePoint}
						  operatorsFilterByPrivatePoint={operatorsFilterByPrivatePoint}
						  driversFilterByPrivatePoint={driversFilterByPrivatePoint}
						  branchesFilterByPrivatePoint={branchesFilterByPrivatePoint}
						  setOperatorsFilterByPrivatePoint={setOperatorsFilterByPrivatePoint}
						  setDriversFilterByPrivatePoint={setDriversFilterByPrivatePoint}
						  setBranchesFilterByPrivatePoint={setBranchesFilterByPrivatePoint}
						  employees={employees}
						  editingOperatorByPrivatePoint={editingOperatorByPrivatePoint}
						  editingDriverByPrivatePoint={editingDriverByPrivatePoint}
						  editingBranchByPrivatePoint={editingBranchByPrivatePoint}
						  startEditOperator={startEdit}
						  startEditDriver={startEdit}
						  startEditBranch={startEdit}
						  saveEditOperator={saveEdit}
						  saveEditDriver={saveEdit}
						  saveEditBranch={saveEdit}
						  cancelEditOperator={cancelEdit}
						  cancelEditDriver={cancelEdit}
						  cancelEditBranch={cancelEdit}
						  loadOperators={() => {}}
						  loadDriversByPrivatePoint={loadDriversByPrivatePoint}
						  expandedDriverByPrivatePoint={expandedDriverByPrivatePoint}
						  toggleDriver={toggleDriverPrivatePoint}
						  expandedOperatorByPrivatePoint={expandedOperatorByPrivatePoint}
						  toggleOperatorPrivatePoint={toggleOperatorPrivatePoint}
						  printDriverPass={printDriverPass}
						  downloadDriverPass={downloadDriverPass}
						  privatePoints={privatePoints}
						  topBases={topBases}
						  chpps={chpps}
						/>
						<PrivatePointsMapView branches={allBranches} privatePoints={allPrivatePoints} />
					</>
				)}

				{open === 'drivers' && (
						<AllDriversPanel
							drivers={drivers}
							driversPagination={driversPagination}
							driversFilter={driversFilter}
							setDriversFilter={setDriversFilter}
							loadDriversPage={loadDriversPage}
							blockDriver={async (id) => {
								try {
									await blockDriver(id)
									notifySuccess('Водитель заблокирован')
									loadDriversPage(driversPagination.page || 1)
								} catch (err) {
									notifyError(err, 'Не удалось заблокировать водителя')
								}
							}}
							unblockDriver={async (id) => {
								try {
									await unblockDriver(id)
									notifySuccess('Водитель разблокирован')
									loadDriversPage(driversPagination.page || 1)
								} catch (err) {
									notifyError(err, 'Не удалось разблокировать водителя')
								}
							}}
							topBases={topBases}
							chpps={chpps}
							privatePoints={privatePoints}
						/>
					)}

					{open === 'driver-checked' && (
						<DriverCheckedPanel setNotify={setNotify} />
					)}

					{open === 'base-requests' && (
						<BaseRequestsAdminPanel setNotify={setNotify} />
					)}

					{open === 'komursvyaz' && (
						<KomurSvyazContent />
					)}
				</div>
				
				{/* Modal for create forms (simple generic implementation) */}
				{modalOpen && (
					<ModalWindow openModal={modalOpen} setOpenModal={setModalOpen} modalTitle={modalType ? `Создать ${modalTypeNames[modalType] || modalType}` : 'Создать'}>
						<div className={styles.div_modal_settings}>
							{modalType === 'guard' && (
								<CreateGuardForm
									employees={employees}
									employeeSearch={employeeSearch}
									setEmployeeSearch={setEmployeeSearch}
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createGuard={createGuard}
									loadGuards={loadGuards}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'topbase' && (
								<CreateTopBaseForm
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createTopBase={createTopBase}
									loadTopBases={loadTopBases}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'chpp' && (
								<CreateChppForm
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createChpp={createChpp}
									loadChpps={loadChpps}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'operator' && (
								<CreateOperatorForm
									employees={employees}
									employeeSearch={employeeSearch}
									setEmployeeSearch={setEmployeeSearch}
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									topBases={topBases}
									createTopBaseOperator={createTopBaseOperator}
									loadOperators={loadOperators}
									uploadOperatorDocuments={uploadOperatorDocuments}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'chpp-operator' && (
								<CreateChppOperatorForm
									employees={employees}
									employeeSearch={employeeSearch}
									setEmployeeSearch={setEmployeeSearch}
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createChppOperator={createChppOperator}
									loadChppOperators={loadOperatorsByChppPage}
									uploadOperatorDocuments={uploadOperatorDocuments}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'driver' && (
								<CreateDriverForm
									employees={employees}
									employeeSearch={employeeSearch}
									setEmployeeSearch={setEmployeeSearch}
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createDriver={createDriver}
									loadDriversByTopBase={loadDriversByTopBase}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
									topBases={topBases}
									setTopBaseSearchByDriver={setTopBaseSearchByDriver}
									topBaseSearchByDriver={topBaseSearchByDriver}
								/>
							)}
							{modalType === 'chpp-driver' && (
								<CreateChppDriverForm
									employees={employees}
									employeeSearch={employeeSearch}
									setEmployeeSearch={setEmployeeSearch}
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createDriver={createDriver}
									loadDriversByChpp={loadDriversByChpp}
									uploadDriverDocuments={uploadDriverDocuments}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'privatepoint' && (
								<CreatePrivatePointForm
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createPrivatePoint={createPrivatePoint}
									loadPrivatePoints={loadPrivatePointsPage}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'privatepoint-operator' && (
								<CreatePrivatePointOperatorForm
									employees={employees}
									employeeSearch={employeeSearch}
									setEmployeeSearch={setEmployeeSearch}
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createPrivatePointOperator={createPrivatePointOperator}
									loadPrivatePointOperators={loadOperatorsByPrivatePointPage}
									uploadOperatorDocuments={uploadOperatorDocuments}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'privatepoint-driver' && (
								<CreatePrivatePointDriverForm
									employees={employees}
									employeeSearch={employeeSearch}
									setEmployeeSearch={setEmployeeSearch}
									modalPayload={modalPayload}
									setModalPayload={setModalPayload}
									closeModal={closeModal}
									createDriver={createDriver}
									loadDriversByPrivatePoint={loadDriversByPrivatePoint}
									uploadDriverDocuments={uploadDriverDocuments}
									notifySuccess={notifySuccess}
									notifyError={notifyError}
								/>
							)}
							{modalType === 'branch' && (
								<CreateBranchForm
									modalPayload={modalPayload}
									onClose={closeModal}
									loadTopBases={loadTopBases}
									loadChpps={loadChpps}
									loadPrivatePoints={loadPrivatePointsPage}
								/>
							)}
						</div>
					</ModalWindow>
				)}
				<Notification notify={notify} setNotify={setNotify} />
			</div>

		</Layout>

	)
}

export default AdminPanelPage
